import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = 'Electric Charge Calculator - Calculate Electric Charge Magnitude';
const DESCRIPTION = 'The electric charge calculator is used to calculate the magnitude of electric charge on two charged objects using Coulomb\'s law for electrical interactions.';
const KEYWORDS = 'Electric charge, Coulomb law, Calculate electric charge';
const OG_URL = 'https://do-calculate.com/calculator/en/electric-charge';
function ElectricChargeCalculator() {
    const [force, setForce] = useState('');
    const [distance, setDistance] = useState('');
    const [chargeMagnitude, setChargeMagnitude] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!force || !distance) {
            setError('Please enter the force and distance correctly');
            setChargeMagnitude('');
            return;
        }
        const electrostaticConstant = 8.99e9;
        const forceValue = parseFloat(force);
        const distanceValue = parseFloat(distance);
        if (isNaN(forceValue) || isNaN(distanceValue)) {
            setError('Please enter valid numeric values');
            setChargeMagnitude('');
            return;
        }
        const chargeMagnitudeValue = Math.sqrt((forceValue * distanceValue ** 2) / electrostaticConstant);
        setChargeMagnitude(
            `Force between charges: ${forceValue} Newtons <br/>
            Distance between charges: ${distanceValue} meters <br/>
            Electric charge on each object: ${chargeMagnitudeValue.toFixed(2)} Coulombs <br/>
            (Note: The charge was calculated using Coulomb's law for electrical interactions)`
        );
        setError('');
    };
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                        <h2 style={{ fontSize: '18px' }}>How to Calculate Electric Charge</h2>
                                        <p>
                                            You can use this calculator to determine the magnitude of electric charge on two charged objects using Coulomb's law for electrical interactions.
                                        </p>
                                        <p>
                                            Force = (Electric Constant × |Charge 1 × Charge 2|) / (Distance^2)
                                        </p>
                                        <hr />
                                    </div>
                                </div>
                                 <MobileUnderCalAds/>
                                <div className="row">
                                    <div className="col-sm-12 col-md-7 calculatorStyle">
                                        <div className="p-3 mb-2 bg-success text-white">
                                            <h2 style={{ fontSize: '16px' }}>{TITLE}</h2>
                                        </div>
                                        <hr />
                                        <div dir="ltr">
                                            <div>
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Force (Newtons)</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="Force of interaction"
                                                        value={force}
                                                        onChange={(e) => setForce(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Distance (meters)</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="Distance between charges"
                                                        value={distance}
                                                        onChange={(e) => setDistance(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '200px' }}
                                                    />
                                                </div>
                                                <br />
                                                <button
                                                    className="btn btn-success"
                                                    style={{ fontSize: '20px' }}
                                                    onClick={handleCalculate}
                                                >
                                                    Calculate Electric Charge
                                                </button>
                                            </div>
                                            <br />
                                            <div>
                                                {error !== '' ? (
                                                    <p className="p-3 mb-2 bg-warning text-white">Error: {error}</p>
                                                ) : (
                                                    <>
                                                        {chargeMagnitude !== '' && (
                                                            <>
                                                            <p className="p-3 mb-2 bg-success text-white">
                                                                Result:
                                                            </p>
                                                            <p className="p-3 mb-2 bg-info text-black" dangerouslySetInnerHTML={{ __html: chargeMagnitude }}></p>
                                                        </>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <RelatedLinks />
                                    <hr />
                                </div>
                            </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.physicsCalculators} />
                    <br />
                </div>
            </div>
            <br />
        </div>
    );
}
export default ElectricChargeCalculator;
